import { MetaConversionsApiClient } from '@fourthwall/services/dist/MetaConversionsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateMetaConversionTestEventMutation = createMutationHook(
  MetaConversionsApiClient.updateTestEventCode,
  {
    mutationKey: ['metaConversionTestEventUpdate'],
  },
)
